export const strings = {
  type_0: 'Özel Grup',
  type_2: 'Herkese Açık Grup',
  members: '{number} Üye',
  member: '{number} Üye',
  group_owner: 'Grup Sahibi',
  leave_group: 'Gruptan Ayrıl',
  leave_group_title: 'Gruptan ayrılmak istediğinizden emin misiniz?',
  leave_group_subtitle:
    'Bu gruptan yayın gönderemez ve güncellemeleri alamazsınız',

  delete_group: 'Grubu Sil',
  share_group: 'Grubu Paylaş',
  join: 'Katılmak',
  request_to_join: 'Katılma İsteği',
  private_group_message:
    'Bu grup özeldir. Ayrıntıları görüntülemek için katılmanız gerekir',
  withdraw: 'Ayırmak',
  mutual_connections: 'Karşılıklı bağlantılar',
  mutual_groups: 'Karşılıklı gruplar',
  no_mutual_connections: 'Karşılıklı Bağlantı Yok',
  group: '{count} Grup',
  groups: '{count} Gruplar',
  view_members: 'Üyeleri görüntüleme',
  view_owner: 'Sahibini Görüntüle',
  edit_group_details: 'Grup ayrıntılarını düzenleme',
  create_group: 'Grup Oluştur',
  update_group: 'Grubu Düzenle',
  group_logo: 'Grup Logosu',
  group_cover: 'Grup Kapağı',
  upload_logo: 'Logo Yükle',
  upload_cover: 'Kapak Yükle',
  group_name: 'Grup Adı',
  speciality: 'Uzmanlık',
  tags: 'Etiketler',
  optional: 'İsteğe bağlı',
  add_tag: 'Etiket Ekle',
  description: 'Tanım',
  mentions: 'Bahsedilenler',
  add_mention: 'Bahsetme Ekle',
  select_privacy: "Gizlilik'i seçin",
  public_group: 'Herkese Açık Grup',
  public_group_desc:
    'Grup, arama sonuçlarında görünür. Tüm SMM Space kullanıcıları doğrudan katılabilir.',
  ms_public_group_desc:
    'Grup, arama sonuçlarında görünür. Tüm Microsite kullanıcıları doğrudan katılabilir.',
  private_group: 'Özel Grup',
  private_group_desc:
    'Grup, arama sonuçlarında görünür. Üyeler, grup sahiplerine katılmaları için istek gönderebilir.',
  create: 'Yaratmak',
  update: 'Güncelleme',
  cancel: 'İptal etmek',
  errors: {
    avatar_required: 'Grup logosu resmi yüklemeniz gerekiyor',
    cover_required: 'Grup kapak resmini yüklemeniz gerekiyor',
    name_required: 'Grup adı gereklidir',
    name_min_length: 'Grup adı en az 3 karakter olmalıdır',
    name_max_length: 'Grup adı 250 karakterden uzun olamaz',
    description_required: 'Grup açıklaması gereklidir',
    description_min_length: 'Grup açıklaması en az 3 karakter olmalıdır',
    description_max_length: 'Grup açıklaması 2500 karakterden uzun olamaz',
    speciality_id_required: 'Lütfen bir uzmanlık alanı seçin',
    cover_uploading: 'Kapak yükleniyor',
    avatar_uploading: 'Kapak yükleniyor',
  },
  requested: 'Istenen',
  invited: 'Davet',
  no_group: 'Grup Yok',
  all_members: 'Tüm üyeler',
  owner: 'Sahip',
  manage: 'Üstesinden gelmek',
  remove: 'Kaldırmak',
  about_group: 'Grup Hakkında...',
  delete_group_confirmation: 'Grubu silmek istediğinizden emin misiniz?',
};
